import { render, staticRenderFns } from "./c-video.vue?vue&type=template&id=0ec64880&scoped=true"
import script from "./c-video.vue?vue&type=script&lang=js"
export * from "./c-video.vue?vue&type=script&lang=js"
import style0 from "./c-video.vue?vue&type=style&index=0&id=0ec64880&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec64880",
  null
  
)

export default component.exports